import { baseApi } from "./baseApi";

const assignmentApi: any = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getFormSectionsById: builder.query({
      query: (id) => `assignments/${id}/form_sections`
    }),
    getAssignmentById: builder.query({
      query: (id) => `assignments/${id}`
    }),
    createPayment: builder.mutation({
      query: ({ id, paymentData }) => ({
        url: `assignments/${id}/payments`,
        method: "POST",
        body: paymentData
      })
    }),
    createRefund: builder.mutation({
      query: ({ id, paymentData }) => ({
        url: `assignments/${id}/refunds`,
        method: "POST",
        body: paymentData
      })
    }),
    updatePayment: builder.mutation({
      query: ({ id, paymentData }) => ({
        url: `assignments/${id}/payments`,
        method: "PUT",
        body: paymentData
      })
    }),
    updateRefund: builder.mutation({
      query: ({ id, paymentData }) => ({
        url: `assignments/${id}/refunds`,
        method: "PUT",
        body: paymentData
      })
    }),
    deletePayment: builder.mutation({
      query: (data) => ({
        url: `assignments/${data.assignmentId}/payments/${data.paymentId}`,
        method: "DELETE"
      })
    }),
    deleteRefund: builder.mutation({
      query: (data) => ({
        url: `assignments/${data.assignmentId}/refunds/${data.refundId}`,
        method: "DELETE"
      })
    }),
    createOrderItem: builder.mutation({
      query: (data) => ({
        url: `assignments/${data?.id}/add_order_item`,
        method: "POST",
        body: data
      })
    }),
    updateOrderItem: builder.mutation({
      query: (data) => ({
        url: `assignments/${data?.id}/edit_order_item`,
        method: "PUT",
        body: data
      })
    }),
    deleteOrderItem: builder.mutation({
      query: (data) => ({
        url: `assignments/${data.assignmentId}/delete_order_item`,
        method: "DELETE",
        body: data
      })
    }),
    getOrderItems: builder.query({
      query: (id) => ({
        url: `assignments/${id}/order_items`,
        method: "GET"
      })
    }),
    sendCustomerReport: builder.mutation({
      query: (assignmentId) => ({
        url: `print_reports/${assignmentId}/upload_customer_report`,
        method: "POST"
      })
    }),
    sendQuotationPdf: builder.mutation({
      query: (assignmentId) => ({
        url: `print_reports/${assignmentId}/upload_quotation_report`,
        method: "POST"
      })
    }),
    sendQuotation: builder.mutation({
      query: (assignmentId) => ({
        url: `assignments/${assignmentId}/send_quotation`,
        method: "POST"
      })
    }),
    sendPaymentData: builder.mutation({
      query: (assignmentId) => ({
        url: `assignments/${assignmentId}/send_payment_data`,
        method: "POST"
      })
    }),
    viewQuotationReport: builder.mutation({
      query: (assignmentId) => ({
        url: `print_reports/${assignmentId}/view_quotation_report`,
        method: "GET"
      })
    }),
    viewCustomerReport: builder.mutation({
      query: (assignmentId) => ({
        url: `print_reports/${assignmentId}/view_customer_report`,
        method: "POST"
      })
    }),
    viewInvoiceReport: builder.mutation({
      query: (assignmentId) => ({
        url: `print_reports/${assignmentId}/view_invoice_report`,
        method: "POST"
      })
    }),
    sendInvoice: builder.mutation({
      query: (assignmentId) => ({
        url: `print_reports/${assignmentId}/upload_invoice_report`,
        method: "POST"
      })
    }),
    dashboardCounts: builder.query({
      query: () => ({
        url: "dashboard_data_counts",
        method: "GET"
      })
    })
  })
});

export const {
  useGetAssignmentByIdQuery,
  useGetFormSectionsByIdQuery,
  useCreatePaymentMutation,
  useCreateRefundMutation,
  useUpdatePaymentMutation,
  useUpdateRefundMutation,
  useDeletePaymentMutation,
  useDeleteRefundMutation,
  useSendCustomerReportMutation,
  useCreateOrderItemMutation,
  useUpdateOrderItemMutation,
  useDeleteOrderItemMutation,
  useGetOrderItemsQuery,
  useSendQuotationPdfMutation,
  useSendQuotationMutation,
  useViewQuotationReportMutation,
  useViewCustomerReportMutation,
  useSendInvoiceMutation,
  useViewInvoiceReportMutation,
  useSendPaymentDataMutation,
  useLazyDashboardCountsQuery
} = assignmentApi;
